import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-tile-button',
  templateUrl: './tile-button.component.html',
  styleUrls: ['./tile-button.component.scss']
})
export class TileButtonComponent  implements OnInit {

  @Input() dictionaryKey: string;

  @Input() iconCSS: string;

  constructor(
    public translationService: TranslationService
  ) {
    
  }

  ngOnInit(): void { }
  
}
